import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend"
import React, { Component } from 'react'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import { Redirect } from "react-router-dom"
import EventBus from "../../common/EventBus.js"
import GlobalHelper from "../../common/GlobalHelper.jsx"
import ActionButton from "../../common/button/actionbutton.component.jsx"
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import SendSchedulingPageButton from '../../common/button/sendSchedulingPageButton.component.jsx'
import Icon from "../../common/icon/icon.component.jsx"
import ProposalPreviewModal from "../../common/proposal/previewmodal.component.jsx"
import ActionButtonWrapper from '../../common/rich-text/feature-protection-wrappers/actionButtonWrapper.component'
import ButtonWrapper from '../../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component'
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import Integrations from "../../integration/Integrations.jsx"
import NewInvoiceModal from "../../invoice/newmodal.component.jsx"
import ReceivePaymentModal from "../../invoice/receivepaymentmodal.component.jsx"
import NewOrderModal from "../../order/NewOrderModal.tsx"
import InternalNotes from "../../order/internalnotes.component"
import { Guard, Permissions } from "../../role/Guard.jsx"
import { TYPE_EMAIL, TYPE_SMS } from '../../state/conversation/ConversationThreadTypes'
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import ProposalMergeFields from "../../template/MergeFields.jsx"
import ProjectDetailsEditForm from '../project/details.component.jsx'
import QuoteStatusBadge from "../status.component.jsx"
import StatusQuote from "../statusquote.component.jsx"
import QuoteDeclinedReasonModal from "./declinedreasonmodal.component.jsx"
import QuoteEventsTimeLine from "./eventstimeline.component.jsx"
import AnalyticsQuoteAmounts from "./quoteamounts.component.jsx"
import AnalyticsQuoteEmails from "./quoteemails.component.jsx"
import AnalyticsQuoteQuestions from "./quotequestions.component.jsx"
import QuoteStatusTimeLine from "./statustimeline.component.jsx"
import ProposalTimeSpentDoughnut from "./timespentdoughnut.component.jsx"

const messages = defineMessages({
    "po_number": {
        id: 'quote.analytics.note_po_number',
        defaultMessage: 'PO Number',
    },
})

class QuoteAnalytics extends Component {

    constructor(props, context) {
        super(props, context)
        const integrations = AppContext.integrations.filter((integration) =>
            integration.attributes.features.includes((Features.ApprovedQuoteExport)))
        this.state = {
            quote: this.props.quote || null,
            project: this.props.project || null,
            proposal: this.props.proposal || null,
            contractProposal: this.props.contractProposal || null,
            emails: this.props.emails || [],
            internalNotes: this.props.internalNotes || [],
            onRefresh: this.props.onRefresh || function () { },
            onEdit: this.props.onEdit || function () { },
            versions: this.props.versions || [],
            loadingVersion: '',
            redirect: '',
            modal: '',
            accountLimit: null,
            invoices: [],
            orders: [],
            moreLoading: false,
            probability: this.props.project ? parseFloat(this.props.project.attributes.probability) * 10 : 1,
            isEditable: this.props.quote && this.props.quote.attributes.deletedAt === '',
            invoiceEnabled: AppContext.getAccount().isFeatureEnabled(Features.Invoice),
            customFieldDefinitions: [],
            integrationsSupportingApprovedQuoteExport: integrations,
            showAnalyticsQuoteQuestions: true,
            isCreatingProposal: false,
        }
        this.newVersion = this.newVersion.bind(this)
        this.handleRefreshQuote = this.handleRefreshQuote.bind(this)
        this.won = this.won.bind(this)
        this.lost = this.lost.bind(this)
        this.lostAndNewVersion = this.lostAndNewVersion.bind(this)
        this.duplicate = this.duplicate.bind(this)
        this.archive = this.archive.bind(this)
        this.unarchive = this.unarchive.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.exportWord = this.exportWord.bind(this)
        this.exportIntegration = this.exportIntegration.bind(this)
        this.openInvoiceCreationModal = this.openInvoiceCreationModal.bind(this)
        this.closeInvoiceCreationModal = this.closeInvoiceCreationModal.bind(this)
        this.printPdf = this.printPdf.bind(this)
        this.handleOnEdit = this.handleOnEdit.bind(this)
        this.createWorkOrder = this.createWorkOrder.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.openOrderCreationModal = this.openOrderCreationModal.bind(this)
        this.closeOrderCreationModal = this.closeOrderCreationModal.bind(this)
        this.createContractProposal = this.createContractProposal.bind(this)
        this.redirectToContractEditDesign = this.redirectToContractEditDesign.bind(this)
        this.editStatus = this.editStatus.bind(this)
        this.handleSendEmailModal = this.handleSendEmailModal.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })

        AppContext.getApiClient().get('/quotes/' + this.state.quote.id + '/orders').then(res => {
            this.setState({
                orders: res.data
            })
        })

        if (this.state.invoiceEnabled) {
            AppContext.getApiClient().get('/quotes/' + this.state.quote.id + '/invoices').then(res => {
                this.setState({
                    invoices: res.data
                })
            })
        }
        AppContext.getApiClient().get('/custom-field-definitions').then(res => {
            this.setState({
                customFieldDefinitions: res.data,
            })
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            quote: nextProps.quote || null,
            project: nextProps.project || null,
            proposal: nextProps.proposal || null,
            contractProposal: nextProps.contractProposal || null,
            versions: nextProps.versions || [],
            probability: nextProps.project ? parseFloat(nextProps.project.attributes.probability) * 10 : 1,
            emails: nextProps.emails || [],
            internalNotes: nextProps.internalNotes || [],
            isEditable: nextProps.quote && nextProps.quote.attributes.deletedAt === '',
        }, () => {
            if (this.state.proposal && this.state.proposal.attributes.variables) {
                const documentInfoSection = this.state.proposal.attributes.variables.sections.find(s => s.attributes.contentType === 'document-info')
                if (documentInfoSection) {
                    this.setState({
                        showAnalyticsQuoteQuestions: !documentInfoSection.attributes.content.disableChat,
                    })
                }
            }
        })
    }

    handleOnEdit(e) {
        e.preventDefault()
        this.state.onEdit(this.state.quote.id)
    }

    handleVersionChange(id) {
        return function (e) {
            e.preventDefault()
            if (this.state.loadingVersion === id) {
                return
            }
            this.setState({
                loadingVersion: id
            })
            this.state.onRefresh(id)
        }.bind(this)
    }

    newVersion(event) {
        event.preventDefault()
        if (this.state.loadingVersion === 'new-version') {
            return
        }
        this.setState({
            loadingVersion: 'new-version'
        })
        return AppContext.getApiClient().post('/quotes/' + this.state.quote.id + '/version', {}).then(q => {
            this.state.onRefresh(q.id)
        })
    }

    handleRefreshQuote() {
        this.state.onRefresh(this.state.quote.id)
    }

    won(event) {
        event.preventDefault()
        return AppContext.getApiClient().post('/quotes/' + this.state.quote.id + '/approve', {}).then(q => {
            EventBus.dispatch(EventBus.TopicQuoteApproved, {
                quote: q,
            })
            this.handleRefreshQuote()
        })
    }

    lostAndNewVersion(event) {
        event.preventDefault()
        event.preventDefault()

        AppContext.getApiClient().post('/quotes/' + this.state.quote.id + '/version', { declined: true }).then(q => {
            this.state.onRefresh(q.id)
        })
    }

    lost(event) {
        event.preventDefault()
        this.setState({
            modal: <QuoteDeclinedReasonModal
                quoteId={this.state.quote.id}
                onClose={this.handleCloseModal}
                onSubmit={this.handleRefreshQuote}
            />
        })
    }

    duplicate(event) {
        event.preventDefault()
        this.setState({
            redirect: <Redirect to={'/quotes/create-from/' + this.state.project.id + '/' + this.state.quote.id} />
        })
    }

    handleSendEmailModal(modal) {
        this.setState({
            modal: modal
        })
    }

    archive(event) {
        event.preventDefault()
        return AppContext.getApiClient().delete('/quotes/' + this.state.quote.id, {}).then(q => {
            this.handleRefreshQuote()
        })
    }
    unarchive(event) {
        event.preventDefault()
        return AppContext.getApiClient().put('/quotes/' + this.state.quote.id + '/unarchive', {}).then(q => {
            this.setState({ isEditable: true })
            this.handleRefreshQuote()
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.handleRefreshQuote()
    }

    closeInvoiceCreationModal(invoiceId) {
        let state = {
            modal: ''
        }
        if (invoiceId) {
            state.redirect = <Redirect to={'/invoices/' + invoiceId + '/edit'} />
        }
        this.setState(state)
    }

    closeOrderCreationModal(orderId) {
        let state = {
            modal: ''
        }
        if (orderId) {
            state.redirect = <Redirect to={'/orders/' + orderId + '/edit'} />
        }
        this.setState(state)
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: <ProposalPreviewModal
                onClose={this.handleCloseModal}
                hash={this.state.proposal.attributes.hash}
                pdfLink={this.state.proposal.attributes.variables.document.pdfUri}
                publicLink={this.state.proposal.attributes.publicLink}
                proposalType={'quote'}
            />
        })
    }

    createWorkOrder(event) {
        event.preventDefault()
        AppContext.getApiClient().get('/contacts/' + this.state.project.attributes.contactId).then(res => {
            const link = res.attributes.externalLinks.find(l => l.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL)
            if (!link) {
                return
            }
            let notes = this.state.project.attributes.title + '\n' + this.state.customFieldDefinitions.map(d => {
                let line = ''
                let val = this.state.project.attributes.customFieldValues[d.id]
                if (d.attributes.fieldType === 'date') {
                    val = ProposalMergeFields.formatDate(this.state.proposal.attributes.variables, val)
                }
                if (val) {
                    line = d.attributes.name + ': ' + val
                }
                return line
            }).filter(l => l !== '').join('\n')
            let poNumber = this.state.project.attributes.poNumber ?
                this.props.intl.formatMessage(messages["po_number"]) + ': ' + this.state.project.attributes.poNumber + '\n' : ''
            notes = poNumber + notes

            let items = this.state.quote.attributes.items
                .filter(i => !["option-for-customer"].includes(i.attributes.type))
                .map(item => {
                    let discountAmount = '0'
                    let discountPercent = '0'
                    if (item.attributes.discountType === 'currency-value') {
                        discountAmount = item.attributes.discountValue
                    } else if (item.attributes.discountType === 'percent-before-taxes') {
                        discountPercent = String(parseFloat(item.attributes.discountValue) / 100)
                    }
                    const product = item.attributes.itemObject
                    const line = {
                        quantity: item.attributes.calculatedMeasure,
                        price: item.attributes.calculatedUnitPriceWithoutDiscount,
                        cost: item.attributes.totalUnitCost,
                        taxable: item.attributes.taxable,
                        title: product.attributes.title,
                        discountAmount: discountAmount,
                        discountPercent: discountPercent,
                        subtotalAmount: !item.attributes.isTaxInclusive ? item.attributes.subtotalAmount : item.attributes.subtotalAmountInclusive,
                        subtotalCost: item.attributes.subtotalCost,
                    }
                    if (product.attributes.externalLinks && product.attributes.externalLinks.length > 0) {
                        for (let externalLink of product.attributes.externalLinks) {
                            if (externalLink.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL) {
                                line.itemId = externalLink.attributes.externalId
                            }
                        }
                    }
                    return line
                })

            // We are merging lines with the same item because Lightspeed doesn't support multiple lines with the same item
            let mergedItems = []
            for (let item of items) {
                const itemIndex = mergedItems.findIndex(i => i.itemId === item.itemId)
                if (itemIndex !== -1) {
                    mergedItems[itemIndex].subtotalAmount = String(parseFloat(mergedItems[itemIndex].subtotalAmount) + parseFloat(item.subtotalAmount))
                    mergedItems[itemIndex].cost = String(parseFloat(mergedItems[itemIndex].subtotalCost) + parseFloat(item.subtotalCost))
                    mergedItems[itemIndex].quantity = String(parseFloat(mergedItems[itemIndex].quantity) + parseFloat(item.quantity))
                    mergedItems[itemIndex].price = String(parseFloat(mergedItems[itemIndex].subtotalAmount) / parseFloat(mergedItems[itemIndex].quantity))
                    mergedItems[itemIndex].discountAmount = '0'
                    mergedItems[itemIndex].discountPercent = '0'
                } else {
                    mergedItems.push(item)
                }
            }
            items = mergedItems

            let feeCalculations = []
            for (let i in this.state.quote.attributes.totals) {
                const t = this.state.quote.attributes.totals[i]
                feeCalculations = feeCalculations.concat(t.attributes.feeCalculations)
            }
            for (let i in feeCalculations) {
                const calc = feeCalculations[i]
                const title = '[QM-fee] / ' + calc.attributes.fee.attributes.name + ' / ' + calc.attributes.fee.attributes.rate + '%' +
                    ' / ' + calc.attributes.fee.id
                items.push({
                    quantity: '1',
                    price: calc.attributes.amount,
                    cost: '0',
                    taxable: true,
                    title: title,
                    discountAmount: '0',
                    discountPercent: '0',
                })
            }

            for (let i in this.state.quote.attributes.totals) {
                const total = this.state.quote.attributes.totals[i]
                if (parseFloat(total.attributes.discountTotalAmount) > 0) {
                    let title = '[QM-discount] / -'
                    switch (total.attributes.discountType) {
                        case 'currency-value':
                            title += ProposalMergeFields.formatMoney(this.state.proposal.attributes.variables, total.attributes.discountValue)
                            break
                        case 'percent-before-tax':
                            title += ProposalMergeFields.formatPercent(this.state.proposal.attributes.variables, total.attributes.discountValue)
                            break
                    }
                    items.push({
                        quantity: '1',
                        price: total.attributes.discountTotalAmount,
                        cost: '0',
                        taxable: false,
                        note: title,
                        discountAmount: total.attributes.discountTotalAmount,
                        discountPercent: '0',
                    })
                }
            }

            const data = {
                type: "qm-create-work-order",
                text: JSON.stringify({
                    quoteId: this.state.quote.id,
                    quoteIdentifier: this.state.quote.attributes.identifier,
                    customerId: link.attributes.externalId,
                    note: notes,
                    items: items,
                })
            }
            window.postMessage(data, "*")
        })
    }

    exportWord(event) {
        event.preventDefault()
        this.setState({
            moreLoading: true,
            modal: <div className={"d-none"}>
                <iframe width={1280} height={250} src={'/p/proposals/' + this.state.proposal.attributes.hash + '/word'} id={'wordFrame'} />
            </div>
        }, () => {
            setTimeout(() => {
                const header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
                    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
                    "xmlns='http://www.w3.org/TR/REC-html40'>" +
                    "<head><meta charset='utf-8'><title>" + this.state.quote.attributes.identifier + "</title></head><body>";
                const footer = "</body></html>";
                const iframe = document.getElementById('wordFrame');
                const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
                const sourceHTML = header + innerDoc.getElementById("pdf-document").innerHTML + footer

                const source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
                const fileDownload = document.createElement("a");
                document.body.appendChild(fileDownload);
                fileDownload.href = source;
                fileDownload.download = this.state.quote.attributes.identifier + '.doc';
                fileDownload.click();
                document.body.removeChild(fileDownload);
                this.setState({ moreLoading: false })
            }, 4000)
        })
    }

    isIntegrationExportable() {
        return AppContext.hasFeatureIntegration(Features.ApprovedQuoteExport) &&
            this.state.quote.attributes.status === "approved"
    }

    exportIntegration(event, integrationKey) {
        event.preventDefault()
        this.setState({
            moreLoading: true,
        })
        const data = {
            exportIntegrationKey: integrationKey
        }
        return AppContext.getApiClient().post('/quotes/' + this.state.quote.id + '/export', data).then(q => {
            setTimeout(() => {
                this.handleRefreshQuote()
                this.setState({
                    moreLoading: false,
                })
            }, 4000)
        })
    }

    receivePayment(event) {
        event.preventDefault()
        this.setState({
            modal: <ReceivePaymentModal
                onClose={this.handleCloseAndRefresh}
                depositPayableObject={this.state.quote}
                project={this.state.project}
            />
        })
    }

    openInvoiceCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <NewInvoiceModal
                contactId={this.state.project.attributes.contactId}
                sellerId={this.state.project.attributes.assignToUserId}
                quoteId={this.state.quote.id}
                locationId={this.state.quote.attributes.locationId}
                projectId={this.state.project.id}
                onClose={this.closeInvoiceCreationModal}
            />
        })
    }

    openOrderCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <NewOrderModal
                contactId={this.state.project.attributes.contactId}
                sellerId={this.state.project.attributes.assignToUserId}
                quoteId={this.state.quote.id}
                locationId={this.state.quote.attributes.locationId}
                projectId={this.state.project.id}
                groups={this.state.quote.attributes.groups}
                onClose={this.closeOrderCreationModal}
            />
        })
    }

    printPdf(e) {
        const printUrl = this.state.proposal.attributes.printUrl
        GlobalHelper.redirectToPrintPdf(printUrl)
        this.setState({
            moreLoading: false,
        })
    }

    renderIntegrationLogo(integrationKey) {
        return Integrations.getIntegrationLogoImage(integrationKey, '75')
    }

    createContractProposal(e) {
        e.preventDefault()
        if (this.state.contractProposal) {
            return
        }

        this.setState({
            isCreatingProposal: true,
        })
        AppContext.getApiClient().post('/proposals', {
            quoteId: this.state.quote.id,
            type: 'contract',
        }).then((res) => {
            const uri = this.state.editMode ? '?em=1' : ''
            this.setState({
                contractProposal: res,
                isCreatingProposal: false,
                redirect: <Redirect to={'/proposals/' + res.attributes.hash + '/preview' + uri} />,
            })
        })
    }

    redirectToContractEditDesign(event) {
        event.preventDefault()
        if (this.state.contractProposal) {
            const uri = this.state.editMode ? '?em=1' : ''
            this.setState({
                redirect: <Redirect to={'/proposals/' + this.state.contractProposal.attributes.hash + '/preview' + uri} />
            })
        }
    }

    editStatus(event) {
        event.preventDefault()
        this.setState({
            modal: <StatusQuote
                endPoint={'/quotes/' + this.state.quote.id}
                status={this.state.quote.attributes.status}
                currentStatus={this.state.quote.attributes.status}
                onClose={this.handleCloseAndRefresh} />
        })
    }

    render() {
        if (!this.state.quote || !this.state.project || !this.state.proposal) {
            return <div />
        }
        return <div className={'row analytics-page py-3 mb-5'}>
            {this.state.redirect}
            {this.state.modal}
            <div className="col-12">
                <ProjectDetailsEditForm
                    quote={this.state.quote}
                    orders={this.state.orders}
                    proposal={this.state.proposal}
                    project={this.state.project}
                    isEditable={false}
                />
            </div>
            <div className={'col-12 px-0'} style={{ zIndex: 900 }}>
                <div className={'row'}>
                    <div className={'col-12'} style={{ paddingRight: '2rem', paddingLeft: '2rem', }}>
                        <ul className="nav nav-tabs">
                            {this.state.versions.map((q, index) => {
                                let active = ''
                                if (this.state.quote.id === q.id) {
                                    active = 'active'

                                }
                                const isLoading = this.state.loadingVersion === q.id && this.state.loadingVersion !== this.state.quote.id
                                return <li key={q.id} className="nav-item">
                                    <a className={"nav-link " + active} href={'#'} onClick={this.handleVersionChange(q.id)}>
                                        {!isLoading ? <div className="text-center m-0 d-flex align-content-center">
                                            <span>{q.attributes.identifier}</span>
                                            <small className={'text-white ml-1'}>
                                                <QuoteStatusBadge status={q.attributes.status} style={{ color: 'white' }} internal={true} />
                                            </small>
                                        </div> : <span className={'px-5'} >
                                            <LoadingSpinner />
                                        </span>}
                                    </a>
                                </li>
                            })}
                            {this.state.isEditable && this.state.accountLimit &&
                                <li className="nav-item">
                                    <ActionButtonWrapper
                                        message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                            <FormattedMessage
                                                id="listing.search.invoice_document_limit"
                                                defaultMessage="Documents limit exceeded."
                                            /> : ''}
                                        onClick={(e) => this.newVersion(e)}
                                        className={"btn btn-outline-primary"}
                                        protectedClassName={"btn btn-outline-primary"}
                                        premium={false}
                                        protectionRule={!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit)}>
                                        <p className="text-center m-0">
                                            <Icon value={'code-branch'} />
                                            <FormattedMessage
                                                id="quote.analytics.create_new_version_btn"
                                                defaultMessage="New version"
                                            />
                                        </p>
                                    </ActionButtonWrapper>
                                </li>}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-12 ui-module">
                <div className={"row align-items-baseline justify-content-between px-3 d-flex"}>
                    <AnalyticsQuoteAmounts
                        showFullTotal={true}
                        depositPayableObject={this.state.quote}
                        proposal={this.state.proposal}
                    />

                    <div className={'row flex-grow-1'}>
                        <div className={'col-12 border-left'}>
                            <ProposalTimeSpentDoughnut
                                proposalType={this.state.proposal.attributes.variables.document.type}
                                visits={this.state.proposal.attributes.visits}
                                totalTimeSpent={this.state.proposal.attributes.totalTimeSpent}
                                totalTimeSpentOnPricing={this.state.proposal.attributes.totalTimeSpentOnPricingTable}
                            />
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={'col-12'}>
                        <hr />
                    </div>
                </div>
                <QuoteStatusTimeLine quote={this.state.quote} />
                <div className={"row"}>
                    <div className={'col-12'}>
                        <hr />
                    </div>
                </div>
                <div className={"row align-items-baseline"}>
                    <div className={'col-6 mt-2'}>
                        <div className={'row pl-3'}>
                            <div className={'col-12 p-2 border-right'}>
                                <InternalNotes
                                    projectObject={this.state.project}
                                    onRefresh={this.handleRefreshQuote}
                                    internalNotes={this.state.internalNotes}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={'col-6 pl-3'}>
                        {this.state.showAnalyticsQuoteQuestions && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureSms) &&
                            [<div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 mt-1">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.questions_and_answers_sms_label"
                                            defaultMessage="SMS"
                                        />
                                    </strong>
                                </label>
                            </div>,
                            <AnalyticsQuoteQuestions
                                project={this.state.project}
                                publicLink={this.state.proposal.attributes.publicLink}
                                selectedThread={GlobalHelper.getConversationThreadIndex(this.props.project?.attributes?.conversationThreads || [], TYPE_SMS)}
                                threadType={TYPE_SMS}
                                onClose={this.handleCloseAndRefresh}
                                quoteId={this.state.quote.id}
                                contactFirstName={this.state.quote.attributes.contact.attributes.firstName}
                            />]
                        }
                        {this.state.showAnalyticsQuoteQuestions &&
                            [<div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 mt-1">
                                    <strong>
                                        <FormattedMessage
                                            id="quote.analytics.questions_and_answers_label"
                                            defaultMessage="Questions and answers"
                                        />
                                    </strong>
                                </label>
                            </div>,
                            <AnalyticsQuoteQuestions
                                project={this.state.project}
                                selectedThread={GlobalHelper.getConversationThreadIndex(this.props.project?.attributes?.conversationThreads || [], TYPE_EMAIL)}
                                onClose={this.handleCloseAndRefresh}
                                quoteId={this.state.quote.id}
                                contactFirstName={this.state.quote.attributes.contact.attributes.firstName} />]
                        }
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label pt-2 mt-1">
                                <strong>
                                    <FormattedMessage
                                        id="quote.analytics.emails_label"
                                        defaultMessage="Emails"
                                    />
                                </strong>
                            </label>
                        </div>
                        <AnalyticsQuoteEmails
                            project={this.state.project}
                            proposal={this.state.proposal}
                            contractProposal={this.state.contractProposal}
                            emails={this.state.emails}
                            onChange={this.handleRefreshQuote}
                            isEditable={this.state.isEditable}
                        />
                    </div>
                </div>
            </div>
            <div className={'col-12 px-0'}>
                <QuoteEventsTimeLine
                    emails={this.state.emails}
                    project={this.state.project}
                    quote={this.state.quote}
                    proposal={this.state.proposal}
                    contractProposal={this.state.contractProposal}
                    isEditable={this.state.isEditable}
                    invoices={this.state.invoices}
                    onUpdate={this.handleRefreshQuote}
                />
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {this.state.isEditable ? <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                <div className={"d-flex"}>
                                    <div className={""}>
                                        {Guard.isAuthorized(Permissions.DeleteQuote) ? <ConfirmButton
                                            onModalRender={(m, c) => { this.setState({ modal: m }, c) }}
                                            onClick={this.archive}
                                            identifier={this.state.quote.attributes.identifier}
                                            className="btn btn-sm btn-outline-danger mr-2 mb-2"
                                        >
                                            <Icon value={"trash"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="quote.analytics.delete_btn"
                                                defaultMessage="Delete"
                                            />
                                        </ConfirmButton> : null}
                                        <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={this.openPreview} >
                                            <Icon value={"eye"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="quote.analytics.preview_btn"
                                                defaultMessage="Preview"
                                            />
                                        </button>
                                        <a className={'btn btn-sm btn-outline-primary mr-2 mb-2'} href={this.state.proposal.attributes.publicLink} target={'_blank'}>
                                            <Icon value={"external-link-alt"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="quote.analytics.open_quote_btn"
                                                defaultMessage="Open quote"
                                            />
                                        </a>
                                        {GlobalHelper.isDocumentSupported('contracts') && <>
                                            {this.state.contractProposal ?
                                                <a className={'btn btn-sm btn-outline-primary mr-2 mb-2'} href={this.state.contractProposal.attributes.publicLink} target={'_blank'}>
                                                    <Icon value={"external-link-alt"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.open_contract_btn"
                                                        defaultMessage="Open contract"
                                                    />
                                                </a> : <ActionButton
                                                    className="btn btn-sm btn-outline-primary mr-2 mb-2"
                                                    isLoading={this.state.isCreatingProposal}
                                                    onClick={this.createContractProposal}>
                                                    <Icon value={"file-signature"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.create_contract_btn"
                                                        defaultMessage="Create contract"
                                                    />
                                                </ActionButton>
                                            }
                                        </>}

                                    </div>
                                    <div className="mr-2 mb-2 ">
                                        <button className="btn btn-sm btn-outline-primary" type="button" id="dropdownMoreButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {!this.state.moreLoading ? <Icon value={"ellipsis-h"} className={"mr-1"} /> : <LoadingSpinner
                                                height={15}
                                                width={3}
                                                className="px-5"
                                            />}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">
                                            <a className="dropdown-item" href="#" onClick={this.duplicate}>
                                                <Icon value={"clone"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.duplicate_btn"
                                                    defaultMessage="Duplicate"
                                                />
                                            </a>
                                            <a className="dropdown-item" href="#" onClick={this.printPdf}>
                                                <Icon value={"print"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.print_btn"
                                                    defaultMessage="Print"
                                                />
                                            </a>
                                            <a className="dropdown-item" href="#" onClick={this.exportWord}>
                                                <Icon value={"file-word"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.word_export_btn"
                                                    defaultMessage="Export to word"
                                                />
                                            </a>
                                            {this.state.contractProposal &&
                                                <a className="dropdown-item" href="#" onClick={this.redirectToContractEditDesign}>
                                                    <Icon value={'pencil-ruler'} className={'mr-1'} />
                                                    <FormattedMessage
                                                        id="quote.edit.status.edit_contract_design_btn"
                                                        defaultMessage="Edit contract"
                                                    />
                                                </a>
                                            }

                                            {this.isIntegrationExportable() && Guard.isAuthorized(Permissions.ManualQuoteExport) ?
                                                this.state.integrationsSupportingApprovedQuoteExport.map(integration => {
                                                    const integrationKey = integration.attributes.integrationKey
                                                    const alreadyExported = this.state.quote.attributes.externalLinks
                                                        .find(externalLink => externalLink.attributes.integrationKey === integrationKey)
                                                    return !alreadyExported ? <a className="dropdown-item" href="#" onClick={(e) => this.exportIntegration(e, integrationKey)}>
                                                        <Icon value={"cloud-upload-alt"} className={"mr-1"} />
                                                        <FormattedMessage
                                                            id="quote.analytics.integration_export_btn"
                                                            defaultMessage="Export to {integrationName}"
                                                            values={{
                                                                integrationName: <span className="ml-1">
                                                                    {this.renderIntegrationLogo(integrationKey)}
                                                                </span>
                                                            }}
                                                        />
                                                    </a> : ''
                                                }) : ''}
                                            {Guard.isAuthorized(Permissions.UpdateQuoteStatus) && ['cancelled', 'approved', 'declined'].includes(this.state.quote.attributes.status) &&
                                                <a className="dropdown-item" href="#" onClick={this.editStatus}>
                                                    <Icon value={'pencil-ruler'} className={'mr-1'} />
                                                    <FormattedMessage
                                                        id="quote.edit.status.edit_status_btn"
                                                        defaultMessage="Change status"
                                                    />
                                                </a>
                                            }
                                            <a className="dropdown-item" href="#" onClick={this.handleOnEdit}>
                                                <Icon value={"pen"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.edit_btn"
                                                    defaultMessage="Edit"
                                                />
                                            </a>
                                        </div>
                                    </div>

                                </div>

                                {['ordered'].includes(this.state.quote.attributes.status) ?
                                    <div className={""}>
                                        <SendSchedulingPageButton
                                            typeOfDocument={"quotes"}
                                            quoteId={this.state.quote.id}
                                            quote={this.state.quote}
                                            handleSendEmailModal={this.handleSendEmailModal}
                                            handleCloseModal={this.handleCloseModal}
                                        />
                                        {parseFloat(this.state.quote.attributes.depositBalance) > 0 &&
                                            !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                                            <button className="btn btn-outline-success mr-2 mb-2" onClick={this.receivePayment}>
                                                <Icon value={"dollar-sign"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.analytics.receive_payment_btn"
                                                    defaultMessage="Receive payment"
                                                />
                                            </button>}
                                    </div> : ''}
                                {!['approved', 'declined', 'invoiced', 'ordered'].includes(this.state.quote.attributes.status) ? <div className={""}>
                                    <SendSchedulingPageButton
                                        typeOfDocument={"quotes"}
                                        quoteId={this.state.quote.id}
                                        quote={this.state.quote}
                                        handleSendEmailModal={this.handleSendEmailModal}
                                        handleCloseModal={this.handleCloseModal}
                                    />
                                    {parseFloat(this.state.quote.attributes.depositBalance) > 0 &&
                                        !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() ?
                                        <button className="btn btn-outline-success mr-2 mb-2" onClick={this.receivePayment}>
                                            <Icon value={"dollar-sign"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="invoice.analytics.receive_payment_btn"
                                                defaultMessage="Receive payment"
                                            />
                                        </button> : ''}
                                    <button className="btn btn-danger mr-2 mb-2" onClick={this.lost}>
                                        <Icon value={"times"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="quote.analytics.decline_btn"
                                            defaultMessage="Lost"
                                        />
                                    </button>
                                    <button className="btn btn-warning mr-2 mb-2" onClick={this.lostAndNewVersion}>
                                        <Icon value={"code-branch"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="quote.analytics.decline_new_version_btn"
                                            defaultMessage="Lost & new version"
                                        />
                                    </button>
                                    {this.state.quote.attributes.preApprovedAt ? <ActionButton className="btn btn-success mb-2" onClick={this.won}>
                                        <Icon value={"check"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="quote.analytics.approve_btn"
                                            defaultMessage="Won"
                                        />
                                    </ActionButton> : <ConfirmButton
                                        className="btn btn-success mb-2"
                                        onClick={this.won}
                                        onModalRender={(m, c) => { this.setState({ modal: m }, c) }}
                                        message={<FormattedMessage
                                            id="quote.edit.status.approve_non_accepted_quote"
                                            defaultMessage="Your customer has not accepted the proposal yet, do you want to approve it anyway ?"
                                        />}
                                    >
                                        <Icon value={'check'} className={'mr-1'} />
                                        <FormattedMessage
                                            id="quote.analytics.approve_btn"
                                            defaultMessage="Won"
                                        />
                                    </ConfirmButton>}
                                </div> : ''}
                                {['approved', 'invoiced'].includes(this.state.quote.attributes.status) ?
                                    <div className={""}>
                                        <SendSchedulingPageButton
                                            typeOfDocument={"quotes"}
                                            quoteId={this.state.quote.id}
                                            quote={this.state.quote}
                                            handleSendEmailModal={this.handleSendEmailModal}
                                            handleCloseModal={this.handleCloseModal}
                                        />
                                        {parseFloat(this.state.quote.attributes.depositBalance) > 0 &&
                                            !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                                            <ButtonWrapper
                                                module={Features.Invoice}
                                                onClick={(e) => this.receivePayment(e)}
                                                redirectToAccount={true}
                                                className={"btn btn-outline-success mr-2 mb-2"}
                                                protectedClassName={"btn btn-outline-success mr-2 mb-2"}
                                                premium={false}
                                                protectionRule={AppContext.accountFeatureIsEnabled(Features.Invoice)}
                                            >
                                                <Icon value={"dollar-sign"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.analytics.receive_payment_btn"
                                                    defaultMessage="Receive payment"
                                                />
                                            </ButtonWrapper>
                                        }
                                        {GlobalHelper.isBrowserExtensionInstalled() && GlobalHelper.hasLightspeedIntegration() ?
                                            <ActionButtonWrapper
                                                module={Features.Invoice}
                                                onClick={(e) => this.createWorkOrder(e)}
                                                redirectToAccount={true}
                                                className={"btn btn-outline-secondary mr-2 mb-2"}
                                                protectedClassName={"btn btn-outline-secondary mr-2 pb-0 mb-2"}
                                                premium={false}
                                                protectionRule={AppContext.accountFeatureIsEnabled(Features.Invoice)}
                                            >
                                                <img src={'/images/lightspeed_flame_logo.png'} className={'mr-1'} style={{ width: '1rem' }} />
                                                <FormattedMessage
                                                    id="quote.analytics.create_work_order_btn"
                                                    defaultMessage="Create work order"
                                                />
                                            </ActionButtonWrapper>
                                            : ''}
                                        {this.state.accountLimit && GlobalHelper.isDocumentSupported('invoices') &&
                                            <ButtonWrapper
                                                module={Features.Invoice}
                                                onClick={(e) => this.openInvoiceCreationModal(e)}
                                                redirectToAccount={!AppContext.accountFeatureIsEnabled(Features.Invoice)}
                                                message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                                    <FormattedMessage
                                                        id="listing.search.invoice_document_limit"
                                                        defaultMessage="Documents limit exceeded."
                                                    /> : ''}
                                                className={"btn btn-primary mr-2 mb-2"}
                                                protectedClassName={"btn btn-primary mr-2 mb-2"}
                                                tooltipPosition={"top"}
                                                premium={false}
                                                protectionRule={AppContext.accountFeatureIsEnabled(Features.Invoice) && (!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit))}
                                            >
                                                <Icon value={"invoice"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.create_invoice_btn"
                                                    defaultMessage="Create invoice"
                                                />
                                            </ButtonWrapper>
                                        }
                                        {['approved'].includes(this.state.quote.attributes.status) && GlobalHelper.isDocumentSupported('orders') &&
                                            <ButtonWrapper
                                                module={AccountFeatures.FeatureOrder}
                                                onClick={(e) => this.openOrderCreationModal(e)}
                                                redirectToAccount={true}
                                                className={"btn btn-success mr-2 mb-2"}
                                                protectedClassName={"btn btn-success mr-2 mb-2"}
                                                premium={false}
                                                protectionRule={AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureOrder)}
                                            >
                                                <Icon value={"order"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.create_order_btn"
                                                    defaultMessage="Create order"
                                                />
                                            </ButtonWrapper>
                                        }
                                    </div> : ''}

                            </div> : [<div className="col-3" key={"1"}>
                                <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"} onClick={this.unarchive}>
                                    <FormattedMessage
                                        id="quote.analytics.unarchive_btn"
                                        defaultMessage="Unarchive"
                                    />
                                </ActionButton>
                            </div>,
                            <div className="col-9" key={"2"}>
                                <p className="text-align-right text-warning m-0">
                                    <FormattedMessage
                                        id="quote.analytics.archived_quote_info"
                                        defaultMessage="This quote is archived and can't be found in search results."
                                    />
                                </p>
                            </div>]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default injectIntl(QuoteAnalytics)





// WEBPACK FOOTER //
// ./src/quote/analytics/analytics.component.jsx